// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"a51317a4","97":"c1f267fa","453":"7ed73881","455":"a2cae4ea","977":"d1107e7f"}[chunkId] + ".chunk.js";
};